import colors from "../../../../../../config/colors";
import TimeView from '../../../../../common/TimeView';

export function getFormattedRows(data,duration,formatter,unit) {
  return data.xAxis.map((time, index) => {
    return [
      new Date(time),
      data.yAxis[index],

      `<div
        style="padding:5px;background-color: ${colors.background};color: ${colors.darkPrimary};display:flex;align-items: center;font-size: 16px";
        "
      >
        ${duration === "1D" ? (
          ""
        ) : (
         ` <span>
            ${new Date(time).getDate() < 10
              ? "0" + new Date(time).getDate()
              : new Date(time).getDate()}-${new Date(time).getMonth() < 10
              ? "0" + (new Date(time).getMonth() + 1)
              : new Date(time).getMonth() + 1}-${new Date(time).getFullYear()}
          </span>`
        )}
        ${duration === "1D" ? TimeView({time})  : ``}
        <span
          style="
            color: ${data.yAxis[index] > 0 ? colors.green : colors.red};
            text-align: right;
            padding-left: 10px;
          "
        >
          ${formatter(data.yAxis[index])} ${unit === "" ? "" : data.yAxis[index] === 1 ? unit : unit+"s"}
        </span>
      </div>`,
    ];
  });
}
